import { render, staticRenderFns } from "./motion_detection.config.vue?vue&type=template&id=ef8a03da"
import script from "./motion_detection.config.vue?vue&type=script&lang=js"
export * from "./motion_detection.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports